<template>
    <div id="app">
        <transition name="slide-up-fade" v-if="showCookieBar">
            <div class="cookie-bar">
                <p>
                    This site uses cookies, you have to accept it to use!
                </p>
                <button class="btn-white-outline" @click="acceptCookies">
                    Accept it
                </button>
            </div>
        </transition>


        <div class="container">
            <h3>Your <u>IPv4</u> address:</h3>
            <div class="ip-box text-center">
                <p v-if="ipInfo.ipVersion == 4">
                    {{ipInfo.ipAddress}}
                    <input type="hidden" id="ip-address" :value="ipInfo.ipAddress">
                    <img src="/images/copy-icon.svg" @click="copyToClipBoard">
                </p>
                <p v-else>
                    N/A
                </p>
            </div>

            <h3>Your <u>IPv6</u> address:</h3>
            <div class="ip-box text-center sm">
                <p v-if="ipInfo.ipVersion == 6">
                    {{ipInfo.ipAddress}}
                    <input type="hidden" id="ip-address" :value="ipInfo.ipAddress">
                    <img src="/images/copy-icon.svg" @click="copyToClipBoard">
                </p>
                <p v-else>
                    N/A
                </p>
            </div>

            <a href="javascript:;" @click="showList" class="view-details">+ View details</a>

            <ul class="ip-datas">
                <!--<transition-group name="list-complete">-->

                <transition-group
                        appear
                        name="staggered-fade"
                        tag="ul"
                        v-bind:css="false"
                        v-on:before-enter="beforeEnter"
                        v-on:enter="enter"
                        v-on:leave="leave"
                >
                    <li v-for="(val,key, i) in ipInfo" :data-i="i" :key="i" v-if="i < indexOfAnimation"
                        class="list-complete-item">
                        <b>{{key}}:</b> {{val}}
                    </li>

                </transition-group>

                <!--</transition-group>-->

            </ul>
            <div id="mapid" style="height: 350px"></div>
            <template v-if="pages.length > 0">
                <p class="pages-sentence">
                    Learn more about your IP address:
                </p>
                <ul class="page-list">
                    <li v-for="page in getStandardPages()">
                        <router-link tag="a" :to="{ name: 'page', params: { slug: page.slug }}">
                            {{page.title}}
                        </router-link>
                    </li>
                </ul>
            </template>
            <div class="links">
                <a href="https://www.codelinks.hu/" target="_blank">Powered by CodeLinks</a>
                <router-link :to="{name: 'page', params: {slug: getTermsAndConditionsSlug()}}">Terms and conditions
                </router-link>
                <router-link :to="{name: 'page', params: {slug: getPrivacyPolicySlug()}}">Privacy Policy</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import Velocity from 'velocity-animate';

    export default {
        data: function () {
            return {
                pages: [],
                ipInfo: {
                    "ipAddress": "-",
                    "countryCode": "-",
                    "regionName": "-",
                    "cityName": "-",
                    "zipCode": "-",
                    "latitude": 0,
                    "longitude": 0,
                    "ipVersion": 0
                },
                showDetails: false,
                showCookieBar: true,
                isAnimating: false,
                ioa: 0
            }
        },
        computed: {
            indexOfAnimation() {
                return this.ioa;
            }
        },
        created: function () {
            var myCookie = this.getCookie("acceptedCookies");

            if (myCookie) {
                this.showCookieBar = false;
                this.fetchPageData();
                this.handleIPData();
            }
        },
        methods: {
            beforeEnter: function (el) {
                el.style.opacity = 0;
                el.style.height = 0;
            },
            enter: function (el, done) {
                var delay = el.dataset.index * 150;
                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 1, height: '1.4rem'},
                        {complete: done}
                    )
                }, delay)
            },
            leave: function (el, done) {
                var delay = el.dataset.index * 150;
                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 0, height: 0},
                        {complete: done}
                    )
                }, delay)
            },
            showList() {
                if (!this.isAnimating) {
                    this.isAnimating = true;
                    if (this.ioa == 0) {
                        var animationInterValPlus = setInterval(() => {
                            this.ioa++;
                            if (this.ioa == 8) {
                                this.isAnimating = false;
                                clearInterval(animationInterValPlus);
                            }

                        }, 125);
                    } else if (this.ioa == 8) {
                        var animationInterValMinus = setInterval(() => {
                            this.ioa--;
                            if (this.ioa == 0) {
                                this.isAnimating = false;
                                clearInterval(animationInterValMinus);
                            }
                        }, 125);
                    }
                }
            },
            fetchPageData() {
                this.axios
                    .get('/?action=PageController_ajaxGetPages')
                    .then(response => {
                        this.pages = Array.isArray(response.data) ? response.data : [];
                    });
            },
            handleIPData() {
                this.axios
                    .get('/?action=IpController_ajaxGetIPInfo')
                    .then(response => {
                        if (typeof response.data === 'object' && "ipAddress" in response.data) {
                            this.ipInfo = response.data;
                            setTimeout(() => {
                                this.initMap();
                            }, 150);
                        }
                    });
            },
            acceptCookies() {
                this.showCookieBar = false;
                var cname = 'acceptedCookies';
                var cvalue = 'accepted';

                var d = new Date();
                d.setTime(d.getTime() + (4 * 30 * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                this.fetchPageData();
                this.handleIPData();
            },
            getStandardPages() {
                return this.pages.filter(function (value, index, arr) {
                    return value.type === "Standard";
                });
            },
            initMap() {
                var ip = this.ipInfo;
                var mymap = L.map('mapid').setView([ip.latitude, ip.longitude], 12);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(mymap);

                if (ip.latitude !== 0 && ip.longitude !== 0) {
                    var marker = L.marker([ip.latitude, ip.longitude]).addTo(mymap);
                    marker.bindPopup("<b>You are here!</b>").openPopup();
                }
            },
            copyToClipBoard() {
                var tempInput = document.createElement("input");
                tempInput.style = "position: absolute; left: -1000px; top: -1000px";
                tempInput.value = this.ipInfo.ipAddress;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);
            },
            getTermsAndConditionsSlug() {
                var obj = this.pages.find(function (el) {
                    return el.type == "Terms and conditions";
                });
                if (obj) {
                    return obj.slug;
                }
                return null;
            },
            getPrivacyPolicySlug() {
                var obj = this.pages.find(function (el) {
                    return el.type == "Privacy Policy";
                });
                if (obj) {
                    return obj.slug;
                }
                return null;
            },
            getCookie(name) {
                var dc = document.cookie;
                var prefix = name + "=";
                var begin = dc.indexOf("; " + prefix);
                if (begin == -1) {
                    begin = dc.indexOf(prefix);
                    if (begin != 0) return null;
                }
                else {
                    begin += 2;
                    var end = document.cookie.indexOf(";", begin);
                    if (end == -1) {
                        end = dc.length;
                    }
                }
                return decodeURI(dc.substring(begin + prefix.length, end));
            }
        }
    }
</script>

<style>
    .slide-fade-enter-active, .slide-up-fade-enter-active {
        transition: all .6s ease;
    }

    .slide-fade-leave-active, .slide-up-fade-leave-active {
        transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(20px);
        opacity: 0;
    }

    .slide-up-fade-enter, .slide-up-fade-leave-to {
        transform: translateY(-20px);
        opacity: 0;
    }
</style>
